import styled from "styled-components";
import { theme } from "../../../../../../constants/StyledComponents";

export const StyledCmSheetFooterContainer = styled.div`
  width: 100%;
  border-top: 1px solid ${theme.colors.purple_2};
  height: 80px;
  align-items: center;
  display: flex;
`;

export const StyledCmSheetFooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px;
  width: 100%;
  margin-left: 40px;
`;
